module.exports = __webpack_public_path__ + "static/media/excel_icon.682a5c3e.png";